(function() {
'use strict';

// ===== CONFIGURAÇÕES — lidas do objeto global injetado pelo Liquid =====
var cfg = window.AmordidaOferta || {};
var META_FRETE_GRATIS = cfg.metaBrinde || 29900; // threshold de frete grátis (nome do campo é legado, não tem mais brinde)

// ===== CROSS-SELL DE PETISCO (venda avulsa, não é o brinde grátis) =====
var PETISCO_IMG = 'https://cdn.shopify.com/s/files/1/0999/1549/7786/files/mignon-suino.webp?v=1783276780';
var PETISCO_VARIANTES = [
  { id: '53597260349754', nome: 'Filé Mignon Suíno', preco: 2490 },
  { id: '53597260382522', nome: 'Tilápia', preco: 3790 },
  { id: '53665223246138', nome: 'Peito de Frango', preco: 2290 },
  { id: '54081961886010', nome: 'Peito de Pato', preco: 2490 }
];
var PETISCO_PRODUTO_HANDLE = 'amordida-petisco-natural-prime-cuts';

// Cache de disponibilidade por variante — evita consultar o estoque a
// cada refresh do carrinho (que roda com bastante frequência).
var petiscoDisponibilidade = null;
var petiscoDisponibilidadeExpira = 0;
var PETISCO_CACHE_MS = 2 * 60 * 1000; // 2 minutos

function atualizarDisponibilidadePetisco() {
  var agora = Date.now();
  if (petiscoDisponibilidade && agora < petiscoDisponibilidadeExpira) {
    return Promise.resolve(petiscoDisponibilidade);
  }
  return fetch('/products/' + PETISCO_PRODUTO_HANDLE + '.js')
    .then(function(r) { return r.json(); })
    .then(function(produto) {
      var mapa = {};
      (produto.variants || []).forEach(function(v) {
        mapa[String(v.id)] = v.available;
      });
      petiscoDisponibilidade = mapa;
      petiscoDisponibilidadeExpira = Date.now() + PETISCO_CACHE_MS;
      return mapa;
    })
    .catch(function() {
      // Se a consulta falhar, não bloqueia a exibição — assume disponível
      // e deixa o /cart/add.js real pegar o erro se estiver esgotado.
      return petiscoDisponibilidade || {};
    });
}

// ===== DEBOUNCE MAP =====
var pendingUpdates = {};

// ===== FORMATAÇÃO =====
function formatMoney(cents) {
  return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
}

// ===== CART API =====
function fetchCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}

function addToCart(variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  }).then(function(r) { return r.json(); });
}

function updateQuantity(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function(r) {
    return r.json().then(function(data) {
      if (!r.ok || data.status) throw data;
      return data;
    });
  });
}

function removeItem(key) {
  return updateQuantity(key, 0);
}

// ===== MENSAGEM TEMPORÁRIA =====
function showCartMessage(message) {
  var bar = document.getElementById('amordida-frete-bar');
  if (bar) {
    bar.innerHTML = '<div class="amordida-cart-alert">' + message + '</div>';
  }
  // Sempre atualiza o carrinho depois, mesmo sem a barra de frete na
  // página — garante que qualquer botão preso em "Adicionando..." se
  // recupere.
  setTimeout(function() { refreshCart(); }, 1800);
}

// ===== ESTADO VAZIO / CHEIO =====
function toggleCartState(itemCount) {
  var freteBar = document.getElementById('amordida-frete-bar');
  var freteHeader = document.getElementById('amordida-frete-header');
  var footer = document.querySelector('.amordida-cart-drawer__footer');
  var upsell = document.getElementById('amordida-upsell-wrap');
  var crosssell = document.getElementById('amordida-crosssell-petisco');

  if (itemCount === 0) {
    if (freteBar) freteBar.style.display = 'none';
    if (freteHeader) freteHeader.style.display = 'none';
    if (footer) footer.style.display = 'none';
    if (upsell) upsell.style.display = 'none';
    if (crosssell) crosssell.remove();
  } else {
    if (freteBar) freteBar.style.display = '';
    if (freteHeader) freteHeader.style.display = 'none';
    if (footer) footer.style.display = '';
  }
}

// ===== OPTIMISTIC QTY UPDATE =====
function changeQtyOptimistic(key, delta) {
  var item = document.querySelector('.amordida-cart-item[data-key="' + key + '"]');
  if (!item) return;

  var numEl = item.querySelector('.amordida-cart-item__qty-num');
  if (!numEl) return;

  var currentQty = parseInt(numEl.textContent) || 0;
  var novaQty = currentQty + delta;
  if (novaQty < 0) novaQty = 0;

  numEl.textContent = novaQty;
  numEl.classList.add('amordida-cart-item__qty-num--syncing');

  var precoEl = item.querySelector('.amordida-cart-item__preco');
  var precoUnit = parseInt(item.dataset.price) || 0;
  if (precoEl) precoEl.textContent = formatMoney(precoUnit * novaQty);

  var compareEl = item.querySelector('.amordida-cart-item__preco-compare');
  if (compareEl) {
    var compareUnit = parseInt(item.dataset.comparePrice) || 0;
    if (compareUnit) compareEl.textContent = formatMoney(compareUnit * novaQty);
  }

  var btnMinus = item.querySelector('.amordida-cart-item__qty-btn[data-action="minus"]');
  if (btnMinus) btnMinus.disabled = novaQty <= 1;

  if (!pendingUpdates[key]) pendingUpdates[key] = {};
  pendingUpdates[key].qty = novaQty;

  if (pendingUpdates[key].timer) clearTimeout(pendingUpdates[key].timer);

  pendingUpdates[key].timer = setTimeout(function() {
    var finalQty = pendingUpdates[key].qty;
    delete pendingUpdates[key];
    numEl.classList.remove('amordida-cart-item__qty-num--syncing');

    if (finalQty === 0) {
      removeItem(key).then(function() { refreshCart(); });
    } else {
      updateQuantity(key, finalQty).then(function(cart) {
        renderSubtotal(cart);
        updateFreteBar(cart);
        renderCrossSellPetisco(cart);
      }).catch(function(error) {
        var msg = 'Quantidade máxima disponível em estoque.';
        if (error && error.description) msg = error.description;
        else if (error && error.message) msg = error.message;
        showCartMessage(msg);
      });
    }
  }, 600);
}

// ===== BARRA DE FRETE GRÁTIS =====
function updateFreteBar(cart) {
  var bar = document.getElementById('amordida-frete-bar');
  if (!bar) return;

  var total = cart.total_price;
  var faltam = META_FRETE_GRATIS - total;
  var progresso = Math.min((total / META_FRETE_GRATIS) * 100, 100);

  if (cart.item_count === 0) {
    bar.innerHTML = '';
    bar.style.display = 'none';
    return;
  }

  if (total >= META_FRETE_GRATIS) {
    bar.innerHTML =
      '<div class="amordida-frete-gratis">' +
        '<div class="amordida-frete-gratis__msg amordida-frete-gratis__msg--ok">🎉 Frete grátis desbloqueado!</div>' +
        '<div class="amordida-frete-gratis__track">' +
          '<div class="amordida-frete-gratis__fill" style="width:100%"></div>' +
        '</div>' +
      '</div>';
    return;
  }

  bar.innerHTML =
    '<div class="amordida-frete-gratis">' +
      '<div class="amordida-frete-gratis__msg">🚚 Faltam <strong>' + formatMoney(faltam) + '</strong> para frete grátis</div>' +
      '<div class="amordida-frete-gratis__track">' +
        '<div class="amordida-frete-gratis__fill" style="width:' + progresso + '%"></div>' +
      '</div>' +
    '</div>';
}

// ===== CROSS-SELL DE PETISCO (venda avulsa no minicart) =====
// Fica depois da lista de itens e antes do rodapé/subtotal.
// Só oferece os sabores que ainda NÃO estão no carrinho — permite ir
// adicionando um de cada vez. Some de vez só quando os 4 já entraram.
function ehPetiscoCrossSell(item) {
  return PETISCO_VARIANTES.some(function(v) { return String(item.variant_id) === v.id; });
}

function saboresDisponiveis(cart, estoque) {
  return PETISCO_VARIANTES.filter(function(v) {
    var jaNoCarrinho = cart.items.some(function(item) { return String(item.variant_id) === v.id; });
    if (jaNoCarrinho) return false;
    if (estoque && estoque[v.id] === false) return false; // esgotado
    return true;
  });
}

// Token de corrida — como a renderização depende de uma consulta
// assíncrona (estoque), se o carrinho mudar de novo antes dessa consulta
// voltar, a resposta mais antiga não pode sobrescrever a mais recente.
var crossSellRenderToken = 0;

function renderCrossSellPetisco(cart) {
  var footer = document.querySelector('.amordida-cart-drawer__footer');
  var existente = document.getElementById('amordida-crosssell-petisco');

  if (!footer || cart.item_count === 0) {
    crossSellRenderToken++; // invalida qualquer render pendente
    if (existente) existente.remove();
    return;
  }

  var meuToken = ++crossSellRenderToken;

  atualizarDisponibilidadePetisco().then(function(estoque) {
    if (meuToken !== crossSellRenderToken) return; // uma chamada mais nova já assumiu

    var disponiveis = saboresDisponiveis(cart, estoque);
    var existenteAgora = document.getElementById('amordida-crosssell-petisco');

    if (disponiveis.length === 0) {
      if (existenteAgora) existenteAgora.remove();
      return;
    }

    var opcoesHtml = disponiveis.map(function(v) {
      return '<option value="' + v.id + '" data-preco="' + v.preco + '">' + v.nome + '</option>';
    }).join('');

    var html =
      '<div class="amordida-crosssell-petisco" id="amordida-crosssell-petisco">' +
        '<img src="' + PETISCO_IMG + '" alt="Petisco Amordida" class="amordida-crosssell-petisco__img">' +
        '<div class="amordida-crosssell-petisco__info">' +
          '<p class="amordida-crosssell-petisco__titulo">🍖 Que tal levar um petisco?</p>' +
          '<p class="amordida-crosssell-petisco__desc">Proteína única, 100% natural e desidratado • 60g</p>' +
          '<select class="amordida-crosssell-petisco__select" id="amordida-crosssell-sabor">' + opcoesHtml + '</select>' +
        '</div>' +
        '<button type="button" class="amordida-crosssell-petisco__btn" id="amordida-crosssell-add">' +
          '+ ' + formatMoney(disponiveis[0].preco) +
        '</button>' +
      '</div>';

    if (existenteAgora) {
      existenteAgora.outerHTML = html;
    } else {
      footer.insertAdjacentHTML('beforebegin', html);
    }

    var select = document.getElementById('amordida-crosssell-sabor');
    var btn = document.getElementById('amordida-crosssell-add');

    if (select && btn) {
      select.addEventListener('change', function() {
        var opt = select.options[select.selectedIndex];
        var preco = parseInt(opt.dataset.preco) || 0;
        btn.textContent = '+ ' + formatMoney(preco);
      });

      btn.addEventListener('click', function() {
        var variantId = select.value;
        btn.textContent = 'Adicionando...';
        btn.disabled = true;
        addToCart(variantId, 1).then(function(resultado) {
          if (resultado && resultado.status) {
            // Ex: esgotou entre o carregamento do drawer e o clique
            var msg = resultado.description || resultado.message || 'Esse sabor esgotou. Escolha outro.';
            petiscoDisponibilidadeExpira = 0; // força reconsultar o estoque
            showCartMessage(msg);
            return;
          }
          refreshCart();
        }).catch(function() {
          petiscoDisponibilidadeExpira = 0;
          showCartMessage('Não foi possível adicionar esse sabor agora.');
        });
      });
    }
  });
}

// ===== RENDERIZA ITENS =====
function renderItems(cart) {
  var list = document.getElementById('amordida-cart-items');
  if (!list) return;

  toggleCartState(cart.item_count);

  if (cart.item_count === 0) {
    list.innerHTML =
      '<div class="amordida-cart__vazio">' +
        '<div class="amordida-cart__vazio-icone">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#E73363" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
            '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
          '</svg>' +
        '</div>' +
        '<p class="amordida-cart__vazio-titulo">Seu carrinho está vazio</p>' +
        '<p class="amordida-cart__vazio-subtitulo">Que tal nutrir seu cão da forma mais completa?</p>' +
      '</div>';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    var assinatura = item.selling_plan_allocation ? true : false;
    var ehPetisco = ehPetiscoCrossSell(item);
    var imgTag = '<img src="' + item.image + '" alt="' + item.title + '" class="amordida-cart-item__img">';
    var imgWrap = ehPetisco
      ? '<div class="amordida-cart-item__img-wrap">' + imgTag + '</div>'
      : '<a href="' + item.url + '" class="amordida-cart-item__img-wrap">' + imgTag + '</a>';

    html +=
      '<div class="amordida-cart-item" data-key="' + item.key + '" data-price="' + item.price + '" data-compare-price="' + (item.properties && item.properties['_compare_at_price'] ? item.properties['_compare_at_price'] : 0) + '">' +
        imgWrap +
        '<div class="amordida-cart-item__info">' +
          '<div class="amordida-cart-item__header">' +
            '<p class="amordida-cart-item__nome">' + item.product_title + '</p>' +
            '<button class="amordida-cart-item__remover" data-key="' + item.key + '" aria-label="Remover">✕</button>' +
          '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="amordida-cart-item__variante">' + item.variant_title + '</p>' : '') +
          (assinatura ? '<span class="amordida-cart-item__tag-assinatura">Assinatura</span>' : '') +
          '<div class="amordida-cart-item__footer">' +
            '<div class="amordida-cart-item__qty">' +
              '<button class="amordida-cart-item__qty-btn" data-key="' + item.key + '" data-action="minus"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
              '<span class="amordida-cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="amordida-cart-item__qty-btn" data-key="' + item.key + '" data-action="plus">+</button>' +
            '</div>' +
            '<div class="amordida-cart-item__preco-wrap">' +
              (item.properties && item.properties['_compare_at_price'] ? '<span class="amordida-cart-item__preco-compare">' + formatMoney(item.properties['_compare_at_price']) + '</span>' : '') +
              '<span class="amordida-cart-item__preco">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  });

  list.innerHTML = html;

  list.querySelectorAll('.amordida-cart-item__remover').forEach(function(btn) {
    btn.addEventListener('click', function() {
      removeItem(btn.dataset.key).then(function() { refreshCart(); });
    });
  });

  list.querySelectorAll('.amordida-cart-item__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      changeQtyOptimistic(btn.dataset.key, btn.dataset.action === 'plus' ? 1 : -1);
    });
  });
}

// ===== SUBTOTAL E CONTADOR =====
function renderSubtotal(cart) {
  var el = document.getElementById('amordida-cart-subtotal');
  if (el) el.textContent = formatMoney(cart.total_price);

  var contador = document.getElementById('amordida-cart-count');
  if (contador) contador.textContent = cart.item_count;

  var cartIcon = document.querySelector('cart-icon');
  if (cartIcon) {
    cartIcon.setAttribute('data-cart-count', cart.item_count);
    var bubble = cartIcon.querySelector('.cart-bubble');
    var count = cartIcon.querySelector('.cart-bubble__text-count');
    if (cart.item_count > 0) {
      if (bubble) bubble.classList.remove('visually-hidden');
      if (count) { count.classList.remove('hidden'); count.textContent = cart.item_count; }
    } else {
      if (bubble) bubble.classList.add('visually-hidden');
      if (count) count.classList.add('hidden');
    }
  }
}

// ===== REFRESH COMPLETO =====
function refreshCart() {
  fetchCart().then(function(cart) {
    renderItems(cart);
    renderSubtotal(cart);
    updateFreteBar(cart);
    renderCrossSellPetisco(cart);
  });
}

// ===== DRAWER OPEN/CLOSE =====
function abrirDrawer() {
  var drawer = document.getElementById('amordida-cart-drawer');
  var overlay = document.getElementById('amordida-cart-overlay');
  if (!drawer) return;
  drawer.classList.add('amordida-cart-drawer--open');
  if (overlay) overlay.classList.add('amordida-cart-overlay--open');
  document.documentElement.style.overflow = 'hidden';
  refreshCart();
}

function fecharDrawer() {
  var drawer = document.getElementById('amordida-cart-drawer');
  var overlay = document.getElementById('amordida-cart-overlay');
  if (!drawer) return;
  drawer.classList.remove('amordida-cart-drawer--open');
  if (overlay) overlay.classList.remove('amordida-cart-overlay--open');
  document.documentElement.style.overflow = '';
}

window.amordidaCartAbrir = abrirDrawer;
window.amordidaCartFechar = fecharDrawer;

// ===== ESTILOS DO CROSS-SELL (injetados uma vez — sem depender de CSS externo) =====
(function injetarEstilosCrossSell() {
  if (document.getElementById('amordida-crosssell-petisco-estilos')) return;
  var style = document.createElement('style');
  style.id = 'amordida-crosssell-petisco-estilos';
  style.textContent =
    '.amordida-crosssell-petisco{display:flex;align-items:center;gap:0.75rem;padding:0.75rem 1rem;margin:0 1rem 0.75rem;background:#fff8fa;border:0.5px solid #fde8ef;border-radius:10px;}' +
    '.amordida-crosssell-petisco__img{width:44px;height:44px;object-fit:cover;border-radius:8px;flex-shrink:0;}' +
    '.amordida-crosssell-petisco__info{flex:1;display:flex;flex-direction:column;gap:0.3rem;min-width:0;}' +
    '.amordida-crosssell-petisco__titulo{font-family:"Montserrat Alternates",sans-serif;font-size:0.78rem;font-weight:700;color:#1a1a1a;margin:0;}' +
    '.amordida-crosssell-petisco__desc{font-family:"Open Sans",sans-serif;font-size:0.72rem;color:#777;margin:0;line-height:1.35;white-space:normal;}' +
    '.amordida-crosssell-petisco__select{font-family:"Open Sans",sans-serif;font-size:0.72rem;color:#666;border:0.5px solid #e8e8e8;border-radius:6px;padding:0.2rem 0.4rem;background:#fff;max-width:100%;}' +
    '.amordida-crosssell-petisco__btn{flex-shrink:0;font-family:"Montserrat Alternates",sans-serif;font-size:0.72rem;font-weight:700;color:#fff;background:#E73363;border:none;border-radius:8px;padding:0.5rem 0.75rem;cursor:pointer;white-space:nowrap;transition:opacity 0.2s;}' +
    '.amordida-crosssell-petisco__btn:hover{opacity:0.9;}' +
    '.amordida-crosssell-petisco__btn:disabled{opacity:0.6;cursor:not-allowed;}';
  document.head.appendChild(style);
})();

// ===== INIT =====
document.addEventListener('DOMContentLoaded', function() {

  var overlay = document.getElementById('amordida-cart-overlay');
  if (overlay) overlay.addEventListener('click', fecharDrawer);

  var btnFechar = document.getElementById('amordida-cart-fechar');
  if (btnFechar) btnFechar.addEventListener('click', fecharDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') fecharDrawer();
  });

  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('pdpVariantId').value;
      var btn = document.getElementById('pdpAddToCart');
      if (btn) { btn.textContent = 'Adicionando...'; btn.disabled = true; }
      addToCart(variantId, 1).then(function() {
        if (btn) { btn.textContent = 'Comprar'; btn.disabled = false; }
        abrirDrawer();
      }).catch(function() {
        if (btn) { btn.textContent = 'Comprar'; btn.disabled = false; }
      });
    });
  }

  refreshCart();
});

})();